export const SET_USER_IS_PENDING =
  'rpb2b-react/accountview/SET_USER_IS_PENDING';
export type SET_USER_IS_PENDING = typeof SET_USER_IS_PENDING;

export const SET_USER_ERROR = 'rpb2b-react/accountview/SET_USER_ERROR';
export type SET_USER_ERROR = typeof SET_USER_ERROR;

export const USER_DATA = 'rpb2b-react/user/USER_DATA';
export type USER_DATA = typeof USER_DATA;

export const USER_ACCOUNTS = 'rpb2b-react/user/USER_ACCOUNTS';
export type USER_ACCOUNTS = typeof USER_ACCOUNTS;

export const USER_DATA_ERROR = 'rpb2b-react/user/USER_DATA_ERROR';
export type USER_DATA_ERROR = typeof USER_DATA_ERROR;

export const USER_ACCOUNTS_IS_PENDING =
  'rpb2b-react/user/USER_ACCOUNTS_IS_PENDING';
export type USER_ACCOUNTS_IS_PENDING = typeof USER_ACCOUNTS_IS_PENDING;

export const USER_ACCOUNTS_PAGINATION =
  'rpb2b-react/user/USER_ACCOUNTS_PAGINATION';
export type USER_ACCOUNTS_PAGINATION = typeof USER_ACCOUNTS_PAGINATION;

export const EMAIL_UPDATED = 'rpb2b-react/accountview/EMAIL_UPDATED';
export type EMAIL_UPDATED = typeof EMAIL_UPDATED;

export default {
  SET_USER_IS_PENDING,
  SET_USER_ERROR,
  USER_DATA,
  USER_ACCOUNTS,
  USER_DATA_ERROR,
  USER_ACCOUNTS_IS_PENDING,
  USER_ACCOUNTS_PAGINATION,
  EMAIL_UPDATED
};
